(function () {
  'use strict';

  var SGTheme = window.SGTheme || {};

  SGTheme.selectors = SGTheme.selectors || {
    productCard: '[data-sg-product-card], .bls__product-item, .product-card',
    addToCart: '[data-sg-add-to-cart], .add-to-cart-btn, [name="add"]',
    loading: 'is-loading',
    disabled: 'is-disabled'
  };

  SGTheme.routes = function () {
    return window.routes || {};
  };

  SGTheme.fetchJson = function (url, options) {
    return fetch(url, options || {}).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) {
          var error = new Error(json && json.description ? json.description : response.statusText);
          error.status = response.status;
          error.response = json;
          throw error;
        }

        return json;
      });
    });
  };

  SGTheme.cart = SGTheme.cart || {};

  SGTheme.cart.get = function () {
    return SGTheme.fetchJson('/cart.js');
  };

  SGTheme.cart.addVariant = function (variantId, quantity, properties) {
    var route = SGTheme.routes().cart_add_url || '/cart/add';
    var body = {
      id: variantId,
      quantity: quantity || 1
    };

    if (properties) {
      body.properties = properties;
    }

    return SGTheme.fetchJson(route + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });
  };

  SGTheme.cart.updateHeaderCount = function (count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      if (el.classList.contains('cart-count-drawer')) {
        el.textContent = '(' + count + ')';
      } else {
        el.textContent = count;
      }
    });
  };

  SGTheme.ui = SGTheme.ui || {};

  SGTheme.ui.setLoading = function (element, loading) {
    if (!element) return;
    element.classList.toggle(SGTheme.selectors.loading, Boolean(loading));
    element.setAttribute('aria-busy', loading ? 'true' : 'false');
  };

  SGTheme.events = SGTheme.events || {};

  SGTheme.events.delegate = function (root, eventName, selector, handler) {
    if (!root) return;
    root.addEventListener(eventName, function (event) {
      var target = event.target.closest(selector);
      if (!target || !root.contains(target)) return;
      handler.call(target, event, target);
    });
  };

  window.SGTheme = SGTheme;
})();
